import config from '../helpers/config';

export default (address, customer) => {
  localStorage.setItem(config.mandiAddressKey, JSON.stringify(address));
  localStorage.setItem(config.mandiContactInfo, JSON.stringify(customer));
};
